import _ from 'lodash'

export default {
    computed: {
        task() {
            if (_.isString(this.taskId)) {
                try {
                    return _.defaults(this.$store.getters.taskById(this.taskId) || {}, { propertyValues: {} })
                } catch (e) {
                    console.warn(e)
                }
            } else {
                return false
            }
        },
        taskType() {
            return this.$store.getters.taskTypeById(this.task.taskType.id)
        },
        taskComments() {
            return this.$store.getters.commentsForTask(this.taskId)
        },
        taskAttachments() {
            return this.$store.getters.attachmentByEntityId(this.taskId)
        },
    },
}
